import appraisalStore from "./appraisal/store";
import feedbackStore from "./feedback/store";
import taskManagementStore from "./taskManagement/store";
import trainingStore from "./training/store";

export default {
  namespaced: true,
  modules: {
    appraisal: appraisalStore,
    feedback: feedbackStore,
    task: taskManagementStore,
    training: trainingStore,
  },
};
